var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52575C",
    fillRule: "evenodd",
    d: "M9 1c-1.105 0-2 .895-2 2H6c-.796 0-1.559.316-2.121.879C3.316 4.44 3 5.204 3 6v14c0 .796.316 1.559.879 2.121C4.44 22.684 5.204 23 6 23h12c.796 0 1.559-.316 2.121-.879.563-.562.879-1.325.879-2.121V6c0-.796-.316-1.559-.879-2.121C19.56 3.316 18.796 3 18 3h-1c0-1.105-.895-2-2-2H9zm8 4c0 1.105-.895 2-2 2H9c-1.105 0-2-.895-2-2H6c-.265 0-.52.105-.707.293C5.105 5.48 5 5.735 5 6v14c0 .265.105.52.293.707.187.188.442.293.707.293h12c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V6c0-.265-.105-.52-.293-.707C18.52 5.105 18.265 5 18 5h-1zM9 4v1h6V3H9v1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#52575C",
    fillRule: "evenodd",
    d: "M7 12c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1zM7 17c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSvg);
export default __webpack_public_path__ + "static/media/listSvg.47590ac83f7d082b111515abfd84b36c.svg";
export { ForwardRef as ReactComponent };